import { post} from './api';
import URLS from '@/constants/api';

export const updateDocFiles = async (businessId: string, data: any) => { 

    const endpoint = `${URLS.UPDATE_BUSINESS_WITH_DOCUMENTS}/${businessId}/documents`;
    const response = await post(endpoint, data);
    return response;
};
